type Unit = 'B' | 'KB' | 'MB' | 'GB'

const UNIT_SIZES: Record<Unit, number> = {
  B: 1,
  KB: 1024,
  MB: 1024 ** 2,
  GB: 1024 ** 3,
}

export const convertBytes = (bytes: number, unit: Unit = 'MB') => {
  return bytes / UNIT_SIZES[unit]
}
